import _ from 'lodash'
import { getPathToElementData } from '@wix/thunderbolt-commons'
import type { ElementData, PathToSelector, IManifestPublicElement } from '@wix/thunderbolt-becky-types'

export const getCompIdToPathToSelector = async (
	compIdToReducedManifest: Record<string, IManifestPublicElement['reducedComponentModel']>
): Promise<Record<string, PathToSelector>> => {
	return _.mapValues(compIdToReducedManifest, ({ elementData }, id) => {
		const pathToElementData = getPathToElementData(id, elementData)
		return _.mapValues(pathToElementData, (data: ElementData) => data.selector)
	})
}
